const AVATAR_SESSION_CACHE_PREFIX = "afrimed:avatar:session";
const avatarMemoryCache = new Map();

function buildAvatarSessionCacheKey({ role, userId }) {
  const normalizedRole = String(role || "").trim().toLowerCase();
  const normalizedUserId = String(userId || "").trim();
  if (!normalizedRole || !normalizedUserId) return "";
  return `${AVATAR_SESSION_CACHE_PREFIX}:${normalizedRole}:${normalizedUserId}`;
}

export function readAvatarSessionCache({ role, userId }) {
  const key = buildAvatarSessionCacheKey({ role, userId });
  if (!key || typeof window === "undefined") return "";
  const inMemory = avatarMemoryCache.get(key);
  if (inMemory) return inMemory;
  try {
    const persisted = window.sessionStorage?.getItem(key) || "";
    if (persisted) avatarMemoryCache.set(key, persisted);
    return persisted;
  } catch {
    return "";
  }
}

export function writeAvatarSessionCache({ role, userId, src }) {
  const key = buildAvatarSessionCacheKey({ role, userId });
  const normalizedSrc = String(src || "").trim();
  if (!key || !normalizedSrc || typeof window === "undefined") return;
  avatarMemoryCache.set(key, normalizedSrc);
  try {
    window.sessionStorage?.setItem(key, normalizedSrc);
  } catch {
    // Non-fatal cache miss.
  }
}

export function clearAvatarSessionCache({ role, userId }) {
  const key = buildAvatarSessionCacheKey({ role, userId });
  if (!key || typeof window === "undefined") return;
  avatarMemoryCache.delete(key);
  try {
    window.sessionStorage?.removeItem(key);
  } catch {
    // Non-fatal cache miss.
  }
}
